import request from '@/utils/request'

// 获取产品列表
export const getProductList = (params: any) =>
  request({
    url: '/manage/product',
    method: 'get',
    params
  })

// 获取固定的产品
export const getFixedProduct = (params: any) =>
  request({
    url: `/manage/product/${params.id}`,
    method: 'get',
    params
  })

// 获取代理子产品
export const getAgentProduct = (params: any) =>
  request({
    url: `/manage/agent-product-detail/${params.id}`,
    method: 'get',
  })

// 获取子产品列表
export const getSubProductList = (params: any) =>
  request({
    url: '/manage/sub-product-extra-field',
    method: 'get',
    params
  })

// 获取子产品银行code
export const getSubProductBankCode = (params: any) =>
  request({
    url: `manage/product/${params.parent_product_id}/sub-product/${params.sub_product_id}/bank/`,
    method: 'get',
    params
  })

// 编辑商品
export const setProductInfo = (data: any) =>
  request({
    url: '/manage/product/' + data.id,
    method: 'patch',
    data
  })

// 产品银行编辑
export const setProductBank = (data: any) =>
  request({
    url: '/manage/product/' + data.productId + '/bank/' + data.id,
    method: 'patch',
    data
  })

// 钱包详情
export const walletDetails = (params: any) =>
  request({
    url: '/manage/wallet-address',
    method: 'get',
    params
  })

// 查询钱包地址
export const queryAddress = (data: any) =>
  request({
    url: '/manage/wallet-address/' + data.address + '/query',
    method: 'patch',
    data
  })

// 查询钱包地址详情
export const queryAddressInfo = (params: any) =>
  request({
    url: '/manage/wallet-address/' + params.address,
    method: 'get'
  })

// 钱包地址归集
export const getWalletAddressLog = (params: any) =>
  request({
    url: '/manage/wallet-address/' + params.id + '/collection-logs',
    method: 'get',
    params
  })

// 获取产品列表
export const getProduct = (params: any) =>
  request({
    url: '/manage/merchant/' + params + '/product',
    method: 'get'
  })

// 短信日志
export const getSmsLog = (params: any) =>
  request({
    url: '/manage/sms-log',
    method: 'get',
    params
  })

// 质押钱包
export const getStakeWallet = () =>
  request({
    url: `/manage/stake-wallet`,
    method: 'get'
  })

// 质押记录
export const getStakeRecord = (params: any) =>
  request({
    url: `/manage/stake-record`,
    method: 'get',
    params
  })

// 创建质押
export const addStakeRecord = (data: any) =>
  request({
    url: `/manage/stake-record`,
    method: 'post',
    data
  })

// 解冻质押
export const unfreezePledge = (data: any) =>
  request({
    url: `/manage/stake-record/${data.id}`,
    method: 'patch',
    data
  })

// 批量归集
export const setBatchCollect = (data: any) =>
  request({
    url: '/manage/collect-amount',
    method: 'post',
    data
  })

// 提取冻结金额
export const setWithdrawBalance = () =>
  request({
    url: '/manage/stake-wallet/withdraw-balance',
    method: 'post'
  })

// 提取冻结金额
export const transactionExport = (data: any) =>
  request({
    url: '/manage/wallet-address/transaction/export',
    method: 'post',
    data
  })

/**申请多签*/
export const setApplysig = (data: any) =>
  request({
    url: '/manage/apply-multi-sig',
    method: 'post',
    data
  })
